import { useEffect } from "react";
import HeroSection from "./components/HeroSection";
import UrgencyBar from "./components/UrgencyBar";
import TrustBadges from "./components/TrustBadges";
import BeforeAfter from "./components/BeforeAfter";
import ModulesSection from "./components/ModulesSection";
import CourseStructure from "./components/CourseStructure";
import BonusSection from "./components/BonusSection";
import CtaSection from "./components/CtaSection";
import PricingSection from "./components/PricingSection";
import AboutSection from "./components/AboutSection";
import FaqSection from "./components/FaqSection";
import FooterCta from "./components/FooterCta";
import Footer from "./components/Footer";

export default function Home() {
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href^="#"]');
      if (!anchor) return;

      const href = anchor.getAttribute('href');
      if (!href || href === '#') return;

      const id = href.slice(1);
      const element = document.getElementById(id);
      if (element) {
        e.preventDefault();
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);
  return (
    <main className="min-h-screen" style={{ backgroundColor: "#0D0D0D" }}>
      <UrgencyBar />
      <HeroSection />
      <TrustBadges />
      <BeforeAfter />
      <ModulesSection />
      <CourseStructure />
      <BonusSection />
      <CtaSection />
      <PricingSection />
      <AboutSection />
      <FaqSection />
      <FooterCta />
      <Footer />
    </main>
  );
}